export const APP_URL = 'appUrlLegacy';
export const API_URL = 'apiUrl';
export const ACCESS_TOKEN = 'accessToken';
export const ACCESS_TOKEN_PHOENIX = 'accessTokenPhoenix';

export const MSW_STATUS = 'mswStatus';

export const TEST_OBJECT = 'testObject';
